import { dataTrendPagesSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendPagesSolid = /*#__PURE__*/createIcon(dataTrendPagesSolid)
export default IconTrendPagesSolid
